import { Component, Inject } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
import { Permissions } from 'src/app/core/enums/permissions.enum'

@Component({
  selector: 'app-clustered-signs-data',
  templateUrl: './clustered-signs-data.component.html',
  standalone: false,
})
export class ClusteredSignsDataComponent {
  public layerIds = Layers
  public isClusteredSignsVisible: boolean | undefined
  public isNonDetectionsVisible: boolean | undefined
  public isMatchedSignsLayerVisible: boolean | undefined
  public isBlacklistAreaLayerVisible: boolean | undefined
  public Permissions = Permissions

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers()
    this.isClusteredSignsVisible = layers?.some((layer) => layer === Layers.ClusteredSigns.name)
    this.isNonDetectionsVisible = layers?.some((layer) => layer === Layers.NonDetections.name)
    this.isMatchedSignsLayerVisible = layers?.some((layer) => layer === Layers.MatchedSigns.name)
    this.isBlacklistAreaLayerVisible = layers?.some((layer) => layer === Layers.BlacklistAreas.name)
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.ClusteredSigns.name:
        this.isClusteredSignsVisible = !this.isClusteredSignsVisible
        break
      case Layers.NonDetections.name:
        this.isNonDetectionsVisible = !this.isNonDetectionsVisible
        break
      case Layers.MatchedSigns.name:
        this.isMatchedSignsLayerVisible = !this.isMatchedSignsLayerVisible
        break
      case Layers.BlacklistAreas.name:
        this.isBlacklistAreaLayerVisible = !this.isBlacklistAreaLayerVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          layer !== Layers.ClusteredSigns.name &&
          layer !== Layers.NonDetections.name &&
          layer !== Layers.MatchedSigns.name &&
          layer !== Layers.BlacklistAreas.name,
      )
    if (this.isClusteredSignsVisible) {
      layers.push(Layers.ClusteredSigns.name)
    }
    if (this.isNonDetectionsVisible) {
      layers.push(Layers.NonDetections.name)
    }
    if (this.isMatchedSignsLayerVisible) {
      layers.push(Layers.MatchedSigns.name)
    }
    if (this.isBlacklistAreaLayerVisible) {
      layers.push(Layers.BlacklistAreas.name)
    }
    this.appState.setState(AppPaths.Internal, {
      layers: layers?.toString(),
    })
  }
}
